import { Pipe, PipeTransform } from '@angular/core';
import { DeviceService } from '../services/device.service';

@Pipe({
  name: 'deviceType'
})
export class DeviceTypePipe implements PipeTransform {
  constructor(private deviceService: DeviceService) {
  }

  // TODO: Use service to get this
  transform(tipe: number): string {
    return this.deviceService.getDeviceType(tipe);
  }
}
